export default class FieldVisibility {
	static PRIVATE = "private";
	static PROTECTED = "protected";
	static PUBLIC = "public";
	static NONE = "";
}
